module.exports = __webpack_public_path__ + "static/media/early-wireframe.8632d0aa.png";